import { createAction, props } from '@ngrx/store';
// import { OrderItem } from '@symphony-solo/domain/order/src/lib/models/';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';

export enum CartActionTypes {
  GetCartAction = '[Cart] GetCartAction',
  GetCartSuccessAction = '[Cart] GetCartSuccess',
  GetCartErrorAction = '[Cart] GetCartError',
  ClearStateAction = '[Cart] ClearStateAction',
  ADD_ITEM = '[Cart] Add Item',
  ADD_ITEM_SUCCESS = '[Cart] Add Item Success',
  ADD_ITEM_ERROR = '[Cart] Add Item Error',
  DELETE_ITEM = '[Cart] Delete Item',
  DELETE_ITEM_SUCCESS = '[Cart] Delete Item success',
  DELETE_All_ITEM = '[Cart] Delete All Item',
  UPDATE_ITEM = '[Cart] Update Item',
  LOAD_CART = '[Cart] Load cart',
  CHECK_CART_ITEMS_AVAILABIlITY = '[Cart] Check cart items availability',
  SET_CART_UNAVAILABILE_ITEMS = '[Cart] Set cart un-availabile items',
  SET_TOTAL = '[Cart] Set cart total',
  SET_SUB_TOTAL = '[Cart] Set cart sub total',
  SetAccountID = '[Cart] SetAccountID',
  SetCartStartTime = '[Cart] SetCartStartTime',
}

export const getCartAction = createAction(CartActionTypes.GetCartAction);
export const getCartSuccessAction = createAction(CartActionTypes.GetCartSuccessAction, props<{ cart }>());
export const getCartErrorAction = createAction(CartActionTypes.GetCartErrorAction, props<{ failure: AppStateFailure }>());

export const addCartItemAction = createAction(CartActionTypes.ADD_ITEM);
export const addCartItemSuccessAction = createAction(CartActionTypes.ADD_ITEM_SUCCESS, props<{ cartItem; cartItemIndex }>());
export const addCartItemErrorAction = createAction(CartActionTypes.ADD_ITEM_ERROR, props<{ failure: AppStateFailure }>());

export const deleteCartItemAction = createAction(CartActionTypes.DELETE_ITEM);
export const deleteCartItemSuccessAction = createAction(CartActionTypes.DELETE_ITEM_SUCCESS, props<{ cart }>());
export const deleteCartItemErrorAction = createAction(CartActionTypes.DELETE_ITEM);

export const deleteAllCartItemAction = createAction(CartActionTypes.DELETE_All_ITEM);
export const deleteAllCartItemSuccessAction = createAction(CartActionTypes.DELETE_All_ITEM, props<{ cart }>());
export const deleteAllCartItemErrorAction = createAction(CartActionTypes.DELETE_All_ITEM);

export const updateCartItemAction = createAction(CartActionTypes.UPDATE_ITEM);
export const updateCartItemSuccessAction = createAction(CartActionTypes.UPDATE_ITEM, props<{ cart }>());
export const updateCartItemErrorAction = createAction(CartActionTypes.UPDATE_ITEM, props<{ failure: AppStateFailure }>());

export const loadCartSuccessAction = createAction(CartActionTypes.LOAD_CART, props<{ cart }>());
export const checkCartItemsAvailabilityAction = createAction(CartActionTypes.CHECK_CART_ITEMS_AVAILABIlITY);
export const setCartUnAvailabilItemsAction = createAction(CartActionTypes.SET_CART_UNAVAILABILE_ITEMS, props<{ items }>());

export const setCartTotalAction = createAction(CartActionTypes.SET_TOTAL, props<{ total }>());
export const setCartSubTotalAction = createAction(CartActionTypes.SET_SUB_TOTAL, props<{ subTotal }>());
export const ClearStateAction = createAction(CartActionTypes.ClearStateAction, props<{ actionType: string }>());
export const setAccountID = createAction(CartActionTypes.SetAccountID, props<{ accountID: number }>());

export const setCartStartTimeAction = createAction(CartActionTypes.SetCartStartTime);
